// extracted by mini-css-extract-plugin
export default {"button":"Tq-z","reviewSort":"Uq-z"};